import { useEffect } from "react";

// Keep the tab title right after client-side navigation. The static HTML
// written by scripts/gen-pages.js only sets the title for the page a visitor
// lands on; moving between routes inside the app never reloads that HTML, so
// without this the tab kept the landing page's title - and so did GA4.
// The strings here must match the ones in scripts/gen-pages.js.
const useTitle = (title) => {
    useEffect(() => {
        if (title) document.title = title;
    }, [title]);
};

export default useTitle;
